async function getPositioning(SKU, vehicleID){
  
  var strSKU = SKU + '';
  while (strSKU.length < 7) 
    strSKU = '0' + strSKU;

  var positions;
  var str;
  var obj;

  var url;
  
  var myDiv;
  var divID ;

  //alert(strSKU);
  
  divID = 'part_position_' + strSKU;
  
  myDiv = document.getElementById(divID);

  
  $(myDiv).html("Position: ");
  
  url = 'https://ps-whi-stage.azurewebsites.net/v2/parts/positions?sku=' + strSKU + '&vehicleId=' + vehicleID;
  //url = 'https://ps-whi-test.azurewebsites.net/v2/parts/positions?sku=0204169&vehicleId=453360';

  let response = await fetch(url);
  let data = await response.json();
  var strPosition = data.positions;
  //let positions = await data();
  if ($.trim(strPosition) == "" || strPosition.includes("undefined") ){
    //$(myDiv).html("REMOVE THIS");
    $(myDiv).hide();
  }else{
    $(myDiv).html("Position: " + strPosition);
  }
/*  
    // FETCH
    fetch(url)
    .then(res => res.json())
    .then(data => obj = data)
    .then(obj => objPositions = obj.data.positions)
    .then(function() {
      positions = objPositions;
      //alert("api call");
      $(myDiv).html("Position: " + positions); 
    }).catch(function(){
  });
*/

}


async function getPartNotes(SKU, vehicleID){
  
  var strSKU = SKU + '';
  while (strSKU.length < 7) 
    strSKU = '0' + strSKU;

  //var positions;
  var str;
  var obj;

  var url;
  
  var myDiv;
  var divID ;

  //alert(strSKU);
  
  divID = 'part_notes_' + strSKU;
  
  myDiv = document.getElementById(divID);

  
  url = 'https://ps-whi-stage.azurewebsites.net/v2/parts/fitmentnote?sku=' + strSKU + '&vehicleId=' + vehicleID;
  // Sample Good API call
  //url = 'https://ps-whi-stage.azurewebsites.net/v2/parts/fitmentnote?sku=1132794&vehicleId=422568'

  // TEST unidentified SKU and/or Vehicle ID
  //url = 'https://ps-whi-stage.azurewebsites.net/v2/parts/fitmentnote?sku=113279433&vehicleId=422568'
  

  let response = await fetch(url);
  let data = await response.json();
  const notesList = data.notes;

  
 
  var driveTypes = data.drive_types;
  var submodel_name = data.submodel_name;
  if (notesList.length <= 0 ){
    //$(myDiv).html("REMOVE THIS");
    $(myDiv).hide();
  }else{
    var notesHTML = "Notes:";
    console.log(notesList);
    
    notesHTML = "</br><b>Part Notes</b><ul>";

    for (i=0; i<notesList.length;i++)
    {
        notesHTML = notesHTML + "<li>" + notesList[i] + "</li>";
    }

    
    notesHTML = notesHTML + "<li>Drivetrain: " + driveTypes + "</li><li>Submodel: " + submodel_name + "</li></ul>"
    
    $(myDiv).html(notesHTML);
  }

}